import styled from 'styled-components';
import { getStateColor } from "../../utils/getStateColor";
export const Container = styled.div`
  margin-bottom: 8px;
  width: 100%;
`;
export const LeftIconContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;
export const RightIconContainer = styled(LeftIconContainer)``;
export const Label = styled.label`
  ${_ref => {
  let {
    theme
  } = _ref;
  return theme.fonts.h5;
}}
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 56px;
  padding: 17.5px;
  width: 100%;

  &:focus {
    background-color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return `${theme.colors.secondary}`;
}};
    outline: none;
  }

  &:hover {
    background-color: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return getStateColor(theme.colors.secondary, 'hover');
}};
  }

  &:focus:hover {
    background-color: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return getStateColor(theme.colors.secondary, 'pressed');
}};
  }
`;
export const Text = styled.span`
  color: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.neutralL4;
}};
  flex: 1;
  text-align: left;
  user-select: none;
`;
export const Input = styled.input`
  display: none;

  &:checked ~ ${Label} ${RightIconContainer} {
    transform: rotate(180deg);
  }

  &:checked ~ ${Label} {
    ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.fonts.titleSM;
}}
  }

  &:checked ~ ${Label}:focus {
    background-color: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colors.secondary;
}};
  }

  &:checked ~ ${Label}:hover {
    background-color: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return getStateColor(theme.colors.secondary, 'pressed');
}};
  }

  &:focus {
    background-color: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return `${theme.colors.secondary}`;
}};
    outline: none;
  }

  &:hover {
    background-color: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return getStateColor(theme.colors.secondary, 'hover');
}};
  }

  &:focus:hover {
    background-color: ${_ref11 => {
  let {
    theme
  } = _ref11;
  return getStateColor(theme.colors.secondary, 'pressed');
}};
  }
`;
export const Notification = styled.div`
  ${_ref12 => {
  let {
    theme
  } = _ref12;
  return theme.fonts.labelSM;
}}
  background-color: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.colors.notification;
}};
  border-radius: 10px;
  color: ${_ref14 => {
  let {
    theme
  } = _ref14;
  return theme.colors.neutralL4;
}};
  display: flex;
  height: 16px;
  justify-content: center;
  padding: 3px 11px;
  user-select: none;
  width: 28px;
`;
export const Button = styled.button`
  ${_ref15 => {
  let {
    theme
  } = _ref15;
  return theme.fonts.h5;
}}
  align-items: center;
  background-color: transparent;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 56px;
  padding: 17.5px;
  width: 100%;
`;
export const ChildrenContainer = styled.ul`
  display: none;
  list-style: none;
  margin: 0;
  padding: 0;

  ${Input}:checked ~ & {
    display: block;
  }

  & ${Label} {
    margin: 8px 0;
    padding-left: 32px;
  }

  & :last-child ${Label} {
    margin-bottom: 0;
  }

  & ${Label}::before {
    background-color: ${_ref16 => {
  let {
    theme
  } = _ref16;
  return theme.colors.secondaryL3;
}};
    border-radius: 50%;
    content: '';
    display: block;
    height: 6px;
    width: 6px;
  }

  & ${Input}:checked + ${Label}::before {
    background-color: ${_ref17 => {
  let {
    theme
  } = _ref17;
  return theme.colors.neutralL5;
}};
  }
`;